import { ESdChangeReason } from "@kuika/kuika-cl-model";
import LocalStorageService from "../../../auth/local-storage-service";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import "./workspace-branch.scss";

export interface IWorkspaceBranchProps {}

export interface IWorkspaceBranchState {}

/**
 * Left-region "where am I" element: project over workspace.
 *
 * It reads as the LEFT COLUMN's heading rather than as a control sitting on the header: while the
 * panel is open it takes the panel's width and continues its right hairline upward, so the column
 * is not cut off at the top. Nothing here is framed or pressable; the branch selector that used to
 * sit at its far edge now lives in the right cluster (ToolbarRight), between Issues and the avatar.
 */
class WorkspaceBranch extends PureSdComponent<IWorkspaceBranchProps & IWithSDProps, IWorkspaceBranchState> {
  render() {
    const sd = this.props.sd;
    const projectName: string = sd.project?.name ?? "";
    const workspaceName: string = LocalStorageService.getCurrentDomain() ?? "";
    // Nothing to show pre-project boot — stay out of the layout.
    if (!projectName && !workspaceName) return null;

    // No panel-state branch here on purpose: the heading takes its width straight from
    // `--left-panel-width` in CSS, and that variable keeping its last value through a collapse is
    // exactly what makes collapsing move nothing. Nothing about this element is conditional.
    return (
      <div className="kuika-toolbar__ws-branch" data-testid="workspaceBranch">
        <div className="kuika-toolbar__ws-branch-identity" title={`${workspaceName} — ${projectName}`}>
          <span className="kuika-toolbar__ws-branch-project kuika-typography-small--medium">{projectName}</span>
          <span className="kuika-toolbar__ws-branch-workspace kuika-typography-small">{workspaceName}</span>
        </div>
      </div>
    );
  }

  checkNeedRender = (_: ESdChangeReason): boolean => true;
}

const workspaceBranch = withSD<IWorkspaceBranchProps>(WorkspaceBranch);
export { workspaceBranch as WorkspaceBranch };
